import { Text } from '@react-pdf/renderer';
import React, { useEffect, useState } from 'react';
import { Field, FieldTypeEnum, getClientContactById } from 'wisestep-api';

import { getAutocompleteLabelForClientContact } from '../../../jobs/helper';
import { IInvoicePdf } from '../../types/IInvoicePdf';

import styles from './Styles';

export const InvoicePdfCustomField = ({
  invoice,
  field,
}: {
  invoice: IInvoicePdf;
  field: Field;
}) => {
  const value = invoice.customFields?.[field.name];
  const [clientSPOCName, setClientSPOCName] = useState('');

  useEffect(() => {
    (async () => {
      if (field.type === FieldTypeEnum.ClientSPOC) {
        const {
          data: { data },
        } = await getClientContactById(value);
        setClientSPOCName(getAutocompleteLabelForClientContact(data));
      }
    })();
  }, [field, value]);

  const text = field.type === FieldTypeEnum.ClientSPOC && value ? clientSPOCName : value;

  return (
    text && (
      <>
        <Text style={styles.color_text}>{field.label}:</Text>
        <Text style={styles.text}>{text ?? 'Not Available'}</Text>
      </>
    )
  );
};
